// Перенос сессии, правка одной сессии, все резервы, прошедшие без статуса.
import { RU_DAYS, RU_DAYS_FULL, STATUS, addDays, dowOf, freeWindows, isCommercial, isPastPlanned, minToHm, money, plural,
  priceFor, reserveDue, ruDate, tzCity, windowStarts } from '@praktika/core';
import { afterChange, call } from '../lib/api.ts';
import { busyTimed, ensureBusy } from '../lib/busy.ts';
import { cdot, resVars } from '../lib/colors.ts';
import { $, $$, esc } from '../lib/dom.ts';
import { activeTypes, clientById, daySessions, groupById, groupLabel, meetLabel, sessionById, statusLabel, typeById,
  typeName, workOf } from '../lib/data.ts';
import { SCREENS, back, render, title } from '../lib/nav.ts';
import { chooseSheet, kvBtn, promptSheet } from '../lib/sheet.ts';
import { S, UI } from '../lib/state.ts';
import { convertTime, nowInfo } from '../lib/zones.ts';
import { bindCommon, meetSheet } from './common.ts';
import { confirmReserve, dropReserve } from './session.ts';

SCREENS.move = (app, p) => {
  const s = sessionById(String(p.id));
  if (!s) { app.innerHTML = title('Перенести') + '<div class="empty">Сессия не найдена</div>'; return; }
  const m = UI.move && UI.move.id === s.id ? UI.move : (UI.move = { id: s.id, date: s.date, time: null });
  const type = typeById(s.typeId), c = clientById(s.clientId), clientTz = c && c.tz && c.tz !== S.tz ? c.tz : '';
  const work = workOf(m.date), sess = daySessions(m.date).filter((x) => x.id !== s.id);
  const n = nowInfo(), o: { step: number; busy: ReturnType<typeof busyTimed>; nowMin?: number } =
    { step: S.settings.step || 5, busy: busyTimed(m.date) };
  if (m.date === n.date) o.nowMin = n.min;
  ensureBusy(m.date);
  const win = m.date < n.date ? [] : freeWindows(work, sess, S.types, o), starts: number[] = [];
  for (const w of win) starts.push(...windowStarts(w, { dur: s.dur || type.dur, brk: type.brk }));
  app.innerHTML = title('Перенести', s.clientName) + '<div class="p-sum">Сейчас: <b>' + esc(RU_DAYS[dowOf(s.date)] + ' ' +
    ruDate(s.date) + ', ' + s.start) + '</b> · ' + esc(typeName(s.typeId)) + ' ' + esc(s.dur) + '</div>' +
    '<div class="field"><div class="l">Новый день</div><div class="v">' +
      '<button data-day="-1" style="font-size:22px;padding:0 10px">‹</button>' +
      '<span style="flex:1;text-align:center">' + esc(RU_DAYS_FULL[dowOf(m.date)] + ', ' + ruDate(m.date)) +
      '</span><button data-day="1" style="font-size:22px;padding:0 10px">›</button></div></div>' +
    '<div class="card"><div class="hd">Свободное время</div><div class="chips">' +
      (starts.length ? starts.map((t) => '<button class="chp' + (t === m.time ? ' on' : '') + '" data-time="' + t + '">' +
      minToHm(t) + '</button>').join('') : '<span class="small">' + (work ? 'окон нет' : 'выходной') + '</span>') + '</div>' +
    (m.time !== null && clientTz ? '<p class="p-note" style="padding:0 14px 10px">У ' + esc(c!.callName || c!.name) +
      ' это ' + minToHm(convertTime(m.date, m.time, S.tz, clientTz).min) + ' (' + esc(tzCity(clientTz)) + ').</p>' : '') +
    '</div>' +
    '<div class="btnrow"><button class="btn pri" data-save' + (m.time !== null ? '' : ' disabled') + '>Перенести' +
      (m.time !== null ? ' на ' + RU_DAYS[dowOf(m.date)]!.toLowerCase() + ' ' + minToHm(m.time) : '') + '</button></div>';
  $$('[data-day]', app).forEach((x) => {
    x.onclick = () => { m.date = addDays(m.date, Number(x.getAttribute('data-day'))); m.time = null; render(); };
  });
  $$('[data-time]', app).forEach((x) => { x.onclick = () => { m.time = Number(x.getAttribute('data-time')); render(); }; });
  $('[data-save]', app).onclick = () => {
    if (m.time === null) return;
    void call('moveSession', s.id, m.date, minToHm(m.time), false).then(() => {
      UI.move = null;
      return afterChange('Перенесено').then(back);
    }, () => {});
  };
};

SCREENS.editSession = (app, p) => {
  const s = sessionById(String(p.id));
  if (!s) { app.innerHTML = title('Сессия') + '<div class="empty">Не найдена</div>'; return; }
  const c = clientById(s.clientId);
  const e = UI.edit && UI.edit.id === s.id ? UI.edit : (UI.edit = { id: s.id, typeId: s.typeId, price: s.price,
    meet: s.meet, link: s.link, address: s.address, note: s.note, groupId: s.groupId, cur: s.cur });
  app.innerHTML = title('Изменить сессию', s.clientName) + '<div class="p-sum">' + esc(RU_DAYS[dowOf(s.date)] + ' ' +
    ruDate(s.date) + ', ' + s.start) + ' · ' + esc(statusLabel(s.status)) + '</div>' +
    '<div class="card"><div class="hd">Тип сессии</div><div class="chips">' +
      activeTypes().map((t) => '<button class="chp' + (t.id === e.typeId ? ' on' : '') + '" data-type="' + esc(t.id) + '">' +
      esc(t.name) + ' ' + t.dur + '</button>').join('') + '</div></div>' +
    '<div class="card">' + kvBtn('Группа', groupById(e.groupId)?.name || groupLabel(s), 'data-grp') +
      '<button class="kv" data-price><span class="k">Цена</span><span class="v chev">' + esc(money(e.price, e.cur)) +
      '</span></button>' +
      '<button class="kv" data-meet><span class="k">Встреча</span><span class="v chev">' + esc(meetLabel(e)) +
      '</span></button>' +
      (e.link ? '<div class="kv col"><span class="k">Ссылка</span><span class="v small">' + esc(e.link) + '</span></div>' : '') +
      '<div class="kv"><span class="k">Комментарий</span><input data-note value="' + esc(e.note) +
      '" style="flex:1;text-align:right;border:0;outline:0"></div></div>' +
    '<div class="btnrow"><button class="btn pri" data-save>Сохранить</button></div>';
  $$('[data-type]', app).forEach((x) => { x.onclick = () => { e.typeId = x.getAttribute('data-type'); render(); }; });
  $('[data-price]', app).onclick = () => promptSheet('Цена', e.price, 'number', (v) => {
    if (v !== '') e.price = Number(v);
    render();
  });
  $('[data-meet]', app).onclick = () => meetSheet(e, c, render);
  // другая группа: цена — сразу по её правилу (её можно поправить до сохранения); кто платит — по новой группе
  $('[data-grp]', app).onclick = () => chooseSheet('Группа этой сессии', S.groups.map((g) => ({ value: g.id, label: g.name,
    hint: isCommercial(g) ? 'платит организация' : 'платит клиент' })), e.groupId, (v) => {
    if (v === e.groupId) return;
    e.groupId = v;
    const r = priceFor(c, groupById(v), typeById(e.typeId), S.settings.main_currency);
    if (r.price !== null) { e.price = r.price; e.cur = r.cur; }
    render();
  });
  const note = $<HTMLInputElement>('[data-note]', app);
  note.oninput = () => { e.note = note.value; };
  $('[data-save]', app).onclick = () => {
    void call('updateSession', s.id, { typeId: e.typeId ?? undefined, price: e.price,
      cur: e.cur !== s.cur ? e.cur : undefined, groupId: e.groupId !== s.groupId ? e.groupId : undefined,
      meet: e.meet || undefined, link: e.link, address: e.address, note: e.note }).then(() => {
      UI.edit = null;
      return afterChange('Сохранено').then(back);
    }, () => {});
  };
};

// Все резервы: по клиентам и пакетам. Резерв сам не снимается — здесь решают: подтвердить вариант или снять.
SCREENS.reserves = (app) => {
  const n = nowInfo(), list = S.sessions.filter((x) => x.status === STATUS.RESERVE)
    .sort((a, b) => (a.date + a.start) < (b.date + b.start) ? -1 : 1);
  const packs = new Map<string, typeof list>();
  for (const x of list) {
    const k = x.clientId + '|' + (x.pack || '');
    if (!packs.has(k)) packs.set(k, []);
    packs.get(k)!.push(x);
  }
  let html = title('Резервы', list.length + ' ' + plural(list.length, 'вариант', 'варианта', 'вариантов')) +
    '<p class="p-note">Резерв держит время за клиентом. Сам он не снимается: подтвердите один вариант — про остальные ' +
    'приложение спросит.</p>';
  if (!list.length) html += '<div class="empty">Резервов нет</div>';
  for (const pk of packs.values()) {
    const c = clientById(pk[0]!.clientId);
    html += '<div class="list-h">' + cdot(c) + esc(pk[0]!.clientName) + (pk.length > 1 ? ' · ' + pk.length + ' ' +
      plural(pk.length, 'вариант', 'варианта', 'вариантов') : '') + '</div><div class="p-list">' + pk.map((x) => {
      const due = reserveDue(x, n.date, n.min);
      return '<div class="p-row res' + (due ? ' due' : '') + '" style="' + resVars(c, x) + '"><div class="tm">' +
        esc(x.start) + '</div><div class="who"><div class="n">' + esc(RU_DAYS_FULL[dowOf(x.date)] + ', ' + ruDate(x.date)) +
        '</div><div class="i">' + esc(typeName(x.typeId)) + ' ' + esc(x.dur) + (due ? ' · <b>ждёт решения</b>' : '') +
        '</div></div><div class="rbtns"><button class="btn sec" data-rok="' + esc(x.id) + '">Подтвердить</button>' +
        '<button class="btn txt" data-rno="' + esc(x.id) + '">Снять</button></div></div>';
    }).join('') + '</div>';
  }
  app.innerHTML = html;
  bindCommon(app);
  $$('[data-rok]', app).forEach((b) => { b.onclick = () => confirmReserve(b.getAttribute('data-rok')!); });
  $$('[data-rno]', app).forEach((b) => { b.onclick = () => dropReserve(sessionById(b.getAttribute('data-rno'))); });
};

SCREENS.pastPlanned = (app) => {
  const n = nowInfo();
  const list = S.sessions.filter((x) => isPastPlanned(x, n.date, n.min))
    .sort((a, b) => (a.date + a.start) < (b.date + b.start) ? 1 : -1);
  app.innerHTML = title('Ждут статуса', list.length + '') +
    '<div class="p-sum">Нажмите на сессию и выберите, что с ней было.</div>' +
    (list.length > 1 ? '<div class="btnrow"><button class="btn sec" data-all-done>Все состоялись</button></div>' : '') +
    '<div class="p-list">' +
    (list.length ? list.map((s) => '<button class="p-row" data-sess-open="' + esc(s.id) + '"><div class="tm">' +
      esc(s.start) + '</div><div class="who"><div class="n">' + esc(s.clientName) + '</div><div class="i">' +
      esc(RU_DAYS[dowOf(s.date)] + ' ' + ruDate(s.date)) + ' · ' + esc(typeName(s.typeId)) + ' ' + esc(s.dur) +
      '</div></div><div class="st plan">' + esc(statusLabel(s.status)) + '</div></button>').join('') :
      '<div class="empty">Все сессии разобраны</div>') + '</div>';
  bindCommon(app);
  // разом «Прошла» — когда их накопилось много (например, после подключения календаря)
  const all = $('[data-all-done]', app);
  if (all) all.onclick = () => {
    const w = plural(list.length, 'сессию', 'сессии', 'сессий');
    if (!confirm('Отметить ' + list.length + ' ' + w + ' как «Прошла»? Каждой начислится её цена.')) return;
    void call<{ count: number }>('markPastDone', list.map((s) => s.id))
      .then((r) => afterChange('Отмечено: ' + r.count), () => {});
  };
};
